const EngagementCalculatorType = {
    Default: "Default",
    SimpleRuleBased: "SimpleRuleBased",
    ManagedProfileBased: "ManagedProfileBased",
    ManualProfileBased: "ManualProfileBased"
}

export default EngagementCalculatorType;
